var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportFeedbackTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.5 16.1611L3.92727 9.99971",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.49219 22.1611H10.5013",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.5 28.1611L3.92727 34.3226",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13873_57530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 11.6471V18.5846C15.1562 19.0065 14.5 20.1315 14.5 21.3971C14.5 22.7096 15.1562 23.8346 16 24.2565V31.1471C16 31.7565 16.375 32.319 16.9375 32.5533C17.5 32.7877 18.1562 32.6471 18.5781 32.2252L20.6406 30.1627C22.8906 27.9127 25.9375 26.6471 29.125 26.6471H29.5V32.6471C29.5 33.4908 30.2031 34.1471 31 34.1471H34C34.8438 34.1471 35.5 33.4908 35.5 32.6471V26.6471C37.1875 26.6471 38.5 25.3346 38.5 23.6471V19.1471C38.5 17.5065 37.1875 16.1471 35.5 16.1471H29.125C25.9375 16.1471 22.8906 14.8815 20.6406 12.6315L18.5781 10.6158C18.1562 10.194 17.5 10.0533 16.9375 10.2877C16.375 10.5221 16 11.0846 16 11.6471ZM19 15.2565C21.7656 17.7877 25.375 19.1471 29.125 19.1471H29.5V23.6471H29.125C25.375 23.6471 21.7656 25.0533 19 27.5846V15.2565Z",
    fill: "black",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.6471V18.5846C15.1562 19.0065 14.5 20.1315 14.5 21.3971C14.5 22.7096 15.1562 23.8346 16 24.2565V31.1471C16 31.7565 16.375 32.319 16.9375 32.5533C17.5 32.7877 18.1562 32.6471 18.5781 32.2252L20.6406 30.1627C22.8906 27.9127 25.9375 26.6471 29.125 26.6471H29.5V32.6471C29.5 33.4908 30.2031 34.1471 31 34.1471H34C34.8438 34.1471 35.5 33.4908 35.5 32.6471V26.6471C37.1875 26.6471 38.5 25.3346 38.5 23.6471V19.1471C38.5 17.5065 37.1875 16.1471 35.5 16.1471H29.125C25.9375 16.1471 22.8906 14.8815 20.6406 12.6315L18.5781 10.6158C18.1562 10.194 17.5 10.0533 16.9375 10.2877C16.375 10.5221 16 11.0846 16 11.6471ZM19 15.2565C21.7656 17.7877 25.375 19.1471 29.125 19.1471H29.5V23.6471H29.125C25.375 23.6471 21.7656 25.0533 19 27.5846V15.2565Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13873_57530",
    x: 2.5,
    y: 0.174805,
    width: 48,
    height: 47.9727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13873_57530"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13873_57530",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFeedbackTitle);
export default __webpack_public_path__ + "static/media/report-feedback-title.08ddfb3a01d440a69cc42673c39971fb.svg";
export { ForwardRef as ReactComponent };